import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body14Styles,
  body18Styles,
  paragraph18Styles,
} from "@constants/typography"
import { DesktopOnly, MobileAndTabletOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  padding: 0 20px 105px;

  @media ${breakpoints.tablet} {
    display: flex;
    padding: 0 calc(0.5 / 12 * 100vw) 132px;
  }

  @media ${breakpoints.laptop} {
    display: flex;
    padding: 0 calc(1 / 12 * 100vw) 164px;
  }
`

const Content = styled.div`
  padding-top: 20px;

  @media ${breakpoints.tablet} {
    display: flex;
    width: calc(5 / 12 * 100vw);
    padding: calc(0.5 / 12 * 100vw) 0 calc(0.5 / 12 * 100vw)
      calc(0.5 / 12 * 100vw);
    flex-direction: column;
    justify-content: space-between;
  }

  @media ${breakpoints.laptop} {
    display: flex;
    width: calc(3 / 12 * 100vw);
    padding: calc(0.5 / 12 * 100vw) 0 calc(0.5 / 12 * 100vw)
      calc(1 / 12 * 100vw);
    flex-direction: column;
    justify-content: space-between;
  }

  @media ${breakpoints.desktop} {
    padding: calc(1 / 12 * 100vw) 0 calc(1 / 12 * 100vw) calc(1 / 12 * 100vw);
  }
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    width: 100%;
    height: calc((100vw - 40px) * 1.06);

    @media ${breakpoints.tablet} {
      width: calc(6.5 / 12 * 100vw);
      height: calc(6.5 / 12 * 100vw * 0.6);
      align-self: center;
    }

    @media ${breakpoints.laptop} {
      width: calc(7 / 12 * 100vw);
      height: calc(7 / 12 * 100vw * 0.6);
      align-self: center;
    }

    img {
      object-fit: contain;
    }
  }
`

const Description = styled.div`
  ${body18Styles}

  @media ${breakpoints.tablet} {
    ${paragraph18Styles}
  }

  @media ${breakpoints.laptop} {
    ${paragraph18Styles}
  }
`

const CaptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 44px;

  @media ${breakpoints.tablet} {
    margin-bottom: 0;
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 0;
  }
`

const Caption = styled.div`
  ${body14Styles}
  color: ${colors.mediumGray};
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface ImageCardProps {
  blockId?: string
  caption: string
  description: string
  image: string
}

const ImageCard: React.FC<ImageCardProps> = ({
  blockId,
  caption,
  description,
  image,
}) => {
  return image ? (
    <Container id={blockId || undefined}>
      <ImageWrapper>
        <ImageHelper src={image} />
      </ImageWrapper>
      <Content>
        <DesktopOnly>
          <Description>{description}</Description>
        </DesktopOnly>
        {caption && (
          <CaptionWrapper>
            <Dash />
            <Caption>{caption}</Caption>
          </CaptionWrapper>
        )}
        <MobileAndTabletOnly>
          <Description>{description}</Description>
        </MobileAndTabletOnly>
      </Content>
    </Container>
  ) : null
}

export default ImageCard
